// Using MuiMenu as Interstate doesn't support components in the menu options
import {
  MagnifyingGlassIcon,
  MuiIconButton,
  MuiMenu
} from "@dealer-center/core-components";
import { SearchBar } from "./SearchBar";
import { useState } from "react";
export interface SearchInterface {
  iconOnly?: boolean;
}
export const Search = ({ iconOnly = false }: SearchInterface) => {
  const [anchorSearchEl, setSearchAnchorEl] = useState<null | HTMLElement>(
    null
  );
  if (!iconOnly) return <SearchBar />;
  const menuId = "primary-search-account-menu";
  const handleSearchMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setSearchAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setSearchAnchorEl(null);
  };
  const isSearchMenuOpen = Boolean(anchorSearchEl);

  const renderSearchMenu = (
    <MuiMenu
      keepMounted
      anchorEl={anchorSearchEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right"
      }}
      id={menuId}
      open={isSearchMenuOpen}
      sx={{
        "&>div": {
          overflowY: "unset",
          overflowX: "unset"
        }
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right"
      }}
      onClose={handleMenuClose}
    >
      <SearchBar />
    </MuiMenu>
  );
  return (
    <>
      <MuiIconButton
        aria-controls={menuId}
        aria-haspopup="true"
        aria-label="Search"
        color="inherit"
        size="large"
        onClick={handleSearchMenuOpen}
      >
        <MagnifyingGlassIcon title="Search" />
      </MuiIconButton>
      {renderSearchMenu}
    </>
  );
};
